<template>
    <div class="orderInfoWrap fc ac">
        <!-- <nav-bar></nav-bar> -->
        <!-- <div class="infoBox fc fz26">
            <img class="logo" src="../../../static/imgs/movie/logo.png" alt />
            <p class="mt20">
                <strong class="fz30 bold tc">{{movieInfo.moviename}}</strong>
                <span>({{movieInfo.edition}})</span>
            </p>
            <p class="mt20">
                {{movieInfo.cinemaname}}
                <span>{{movieInfo.roomname}}</span>
            </p>
            <span class="tc mt20">{{movieInfo.playtime | formatTime}}</span>
            <span class="lh35 mt20">{{selectedList.length}}张（{{seatsTxt}}）</span>
            <div class="priceInfo mt20 fc afe">
                <span class="fz36 mt20">
                    应付金额：
                    <strong class="tc">{{movieInfo.price / 100 * selectedList.length}}元</strong>
                </span>
                <span class="mt20">含服务费3元/张</span>
            </div>
        </div>
        <img class="borderImg" src="../../../static/imgs/movie/orderBg.png" alt /> -->
        <div class="movieInfoBox">
            <div class="movieInfo fr ac">
                <img class="poster" :src="movieInfo.logo + '_300x300'" alt="" />
                <div class="basicInfo fc jsb">
                    <div class="fc">
                        <p class="title">
                            <strong>{{ movieInfo.moviename }}</strong>
                            <span class="tc">{{ selectedList.length }}张</span>
                        </p>
                        <p class="red">
                            {{ movieInfo.playtime }} {{ movieInfo.edition }}
                        </p>
                        <p>{{ movieInfo.cinemaname }}</p>
                        <p>{{ movieInfo.roomname }}</p>
                        <p>{{ seatsTxt }}</p>
                    </div>
                    <p class="priceTxt">
                        实付价：<span class="red">￥</span
                        ><span class="price red">{{
                            discountPrice
                                ? discountPrice
                                : (movieInfo.price *
                                      100 *
                                      selectedList.length) /
                                  10000
                        }}</span
                        ><span class="oriPrice"
                            >￥{{
                                (movieInfo.price * 100 * selectedList.length) /
                                10000
                            }}</span
                        >
                    </p>
                </div>
            </div>
        </div>
        <div class="phoneNo fr ac">
            <span>手机号</span>
            <input
                v-model="phoneNo"
                placeholder="请输入手机号码"
                type="number"
            />
            <img src="../../../static/imgs/movie/edit.png" alt />
        </div>
        <div class="notice fc">
            <p class="tc notice_title">* 请核对订单信息，影票售出后不可退换</p>
            <p class="grey notice_content">
                购票须知 :
                <br />1.请确认场次和时间无误，购买成功后将不予退换
                <br />2.由于设备故障等不可抗因素，存在少量场次锁座失败情况
                <br />3.平均10-30分钟出票，超过30分钟未出票请联系客服
                <br />4.出票成功后，将以短信通知提醒您，可到影院取票机取票
            </p>
        </div>
        <button @click="confirmOrder" class="confirmBtn bg_tc">去支付</button>
    </div>
</template>

<script>
import navBar from "../../components/common/navBar.vue";
import { Toast, Indicator } from "mint-ui";
export default {
    data() {
        return {
            auth_code: this.getLocal("auth_code"),
            movieInfo: this.getLocal("movie_info")
                ? this.getLocal("movie_info")
                : {},
            selectedList: this.getLocal("selected_list")
                ? this.getLocal("selected_list")
                : {},
            seatsArr: [],
            seatsIdArr: [],
            seatsTxt: "",
            phoneNo: this.getLocal("phoneNo"),
            discountPrice: this.$route.query.discountPrice
                ? this.$route.query.discountPrice
                : "",
        };
    },
    components: {
        navBar,
    },
    created() {
        console.log(this.movieInfo, this.selectedList);
        // let seatsArr = [];
        for (let i of this.selectedList) {
            this.seatsArr.push(i.name);
            this.seatsIdArr.push(i.seatid);
        }
        this.seatsTxt = this.seatsArr.join("，");
    },
    beforeRouteEnter(to, from, next) {
        window.document.body.style.backgroundColor = "#FFF";
        next();
    },
    beforeRouteLeave(to, from, next) {
        window.document.body.style.backgroundColor = "#f2f2f2";
        next();
    },
    methods: {
        confirmOrder() {
            if (!this.phoneNo) {
                Toast({
                    message: "请输入手机号码",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                return;
            }
            Indicator.open("加载中...");
            this.$post({
                method: "member.order.create",
                auth_code: this.auth_code,
                mobile: this.phoneNo,
                opiid: this.selectedList[0].opiid,
                seatids: this.seatsIdArr.join("|"),
                seatnames: encodeURI(this.seatsArr).split(",").join("|"),
                sdid: this.$route.query.sdid ? this.$route.query.sdid : "",
            })
                .then((res) => {
                    Indicator.close();
                    if (res.success) {
                        let tradeno = res.data.tradeno;
                        this.$router.push({
                            path: "/confirmOrder",
                            query: {
                                tradeno: tradeno,
                                seatsTxt: this.seatsTxt,
                            },
                        });
                    } else {
                        Toast({
                            message: res.error.desp,
                            position: "middle",
                            duration: 2000,
                            className: "toastBox",
                        });
                    }
                })
                .catch((err) => {
                    Indicator.close();
                });
        },
    },
};
</script>
<style lang="scss">
.orderInfoWrap {
    .movieInfoBox {
        height: 348;
        width: 100%;
        .movieInfo {
            height: 260px;
            margin: 38px 0 50px 0;
            width: 100%;
            padding: 0 40px;
            box-sizing: border-box;
            .poster {
                width: 176px;
                height: 260px;
                margin-right: 20px;
            }
            .basicInfo {
                width: calc(100% - 196px);
                height: 260px;
                .title {
                    strong {
                        font-size: 32px;
                    }
                    span {
                        font-size: 28px;
                    }
                }
                p {
                    font-size: 26px;
                    margin-bottom: 10px;
                }
                .priceTxt {
                    font-size: 24px;
                    .price {
                        font-size: 40px;
                    }
                    .oriPrice {
                        margin-left: 20px;
                        color: #999;
                        text-decoration: line-through;
                    }
                }
            }
        }
    }
    .phoneNo {
        width: 684px;
        background-color: #fff;
        height: 70px;
        padding: 10px 0;
        border: 1px solid #bbb; /* no */
        border-radius: 10px;
        margin: 30px 0;
        span {
            width: 140px;
            height: 46px;
            line-height: 46px;
            text-align: center;
            border-right: 1px solid #888;
            font-size: 26px;
        }
        input {
            width: 464px;
            padding: 0 30px;
            font-size: 26px;
        }
        img {
            width: 50px;
            height: 50px;
            margin-right: 30px;
        }
    }
    .notice {
        width: 684px;
        margin-top: 10px;
        padding-bottom: 120px;
        line-height: 50px;
        .notice_title {
            font-size: 20px;
        }
        .notice_content {
            font-size: 24px;
            // display: inline-block;
            max-height: 100%;
        }
    }
    .confirmBtn {
        // width: 100%;
        width: 684px;
        height: 80px;
        position: fixed;
        bottom: 80px;
        color: #fff;
        font-size: 34px;
        border-radius: 10px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/movie/orderInfo.vue